module.exports = __webpack_public_path__ + "static/media/vyapar.18c24730.svg";